
import { doFetch } from '../utils/abortableFetch';


class ChatRoom {
  constructor(signalingServer, logger) {
    this.signalingServer = signalingServer;
    this.logger = logger;
    this.eventSubscription = this.signalingServer().subscribe('event', (data) => this._onEvent(data));

    // initialize handlers to keep track of them and to avoid typescript errors
    this.onEventMessageReceived = (_c, _s, _u, _d, _t) => { };
    this.onPublicMessageReceived = (_c, _s, _f, _fd, _m, _t, _id) => { };
    this.onPrivateMessageReceived = (_c, _s, _to, _tod, _f, _fd, _m, _t, _id) => { };
    this.onPublicSharedFile = (_c, _s, _f, _fd, _m, _t, _id, _fname) => { };
    this.onPrivateSharedFile = (_c, _s, _t0, _tod, _f, _fd, _m, _t, _id, _fname) => { };
  }

  _onEvent(data) {
    if (data.type === 'chat') {
      const msg = data.data;
      const { class: cls, subclass, data: dt } = msg;
      switch (cls) {
        case 'event':
          this.onEventMessageReceived(cls, subclass, dt.username, dt.display_name, dt.ts);
          break;
        case 'message': {
          switch (subclass) {
            case 'public': {
              this.onPublicMessageReceived(
                cls,
                subclass,
                dt.from,
                dt.from_display_name,
                dt.message,
                dt.ts,
                dt.msg_id
              );
              break;
            }
            case 'private': {
              this.onPrivateMessageReceived(
                cls,
                subclass,
                dt.to,
                dt.to_display_name,
                dt.from,
                dt.from_display_name,
                dt.message,
                dt.ts,
                dt.msg_id
              );
              break;
            }
            default: break;
          }
          break;
        }
        case 'shared_file': {
          switch (subclass) {
            case 'public': {
              this.onPublicSharedFile(
                cls,
                subclass,
                dt.from,
                dt.from_display_name,
                dt.message,
                dt.ts,
                dt.msg_id,
                dt.filename
              );
              break;
            }
            case 'private': {
              this.onPrivateSharedFile(
                cls,
                subclass,
                dt.to,
                dt.to_display_name,
                dt.from,
                dt.from_display_name,
                dt.message,
                dt.ts,
                dt.msg_id,
                dt.filename
              );
              break;
            }
            default: break;
          }
          break;
        }
        default: break;
      }
    }
  }

  publishChatMessage(message, to) {
    return this.signalingServer().publishChatMessage(message, to);
  }

  publishChatFile(token, room, file, message, to) {
    const url = '/artifacts/meeting_shared_files/upload';
    const formData = new FormData();
    formData.append("file", file);
    formData.append("room", room);
    formData.append("message", message);
    if (to) {
      formData.append("to", to);
    }
    const request = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Authorization': token },
      body: formData
    };
    return doFetch(url, request);
  }

  tearDown() {
    if (this.eventSubscription) {
      this.signalingServer().unsubscribe('event', this.eventSubscription);
    }
  }
}

export { ChatRoom };
